import React, { useEffect, useState } from "react";
import { TimelineStage, TimelineStageProps } from "./TimelineStage";
import { useAppSelector } from "../../../app/store";
import { isEventsDataFailed, isEventsDataLoading, selectAllEvents } from "../logic/slice";

import { CustomLoadingSpinner } from "../../../components/ui/spinners/LoadingSpinner";
import { ErrorDisplay } from "../../../components/ui/error/ErrorDisplay";
import { RETRIEVING_DATA_SUBTITLE } from "../../../lib/constants";


export const TimelinePanel: React.FC = () => {

  const isLoading = useAppSelector(isEventsDataLoading);
  const isFailed = useAppSelector(isEventsDataFailed);

  const events = useAppSelector(selectAllEvents);

  const [sortedEventStages, setSortedEventStages] = useState<TimelineStageProps[]>([]);

  useEffect(() => {
    const sortedEvents = [...events].sort((a, b) => {
      const dateDiff =
        new Date(`${b.date}T00:00:00Z`).getTime() -
        new Date(`${a.date}T00:00:00Z`).getTime();

      if (dateDiff !== 0) {
        return dateDiff;
      }

      return (
        new Date(b.last_updated_at).getTime() -
        new Date(a.last_updated_at).getTime()
      );
    });

    const sortedEventStages: TimelineStageProps[] = [];

    sortedEvents.forEach((event) => {
      if(sortedEventStages.length && sortedEventStages[sortedEventStages.length - 1].eventType === event.event_type) {
        sortedEventStages[sortedEventStages.length - 1].events.push(event);
      } else {
        sortedEventStages.push({
          eventType: event.event_type,
          events: [event]
        })
      }
    })

    setSortedEventStages(sortedEventStages)

  }, [events]);

  if (isLoading) {
    return (
      <div className="h-[100vh]">
        <CustomLoadingSpinner
          title="Loading Case Timeline..."
          subtitle={RETRIEVING_DATA_SUBTITLE}
          minHeight="min-h-[100vh]" />
      </div>  
    );
  }

  if (isFailed) {
    return <ErrorDisplay error={"Failed to load Case Timeline"} />;
  }

  if (!sortedEventStages.length) {
    return (
      <div className="p-6 text-center items-center rounded-lg">
        <h3 className="font-semibold text-lg mb-1">No Timeline Events Found</h3>
        <p className="text-sm">This case does not have any associated event.</p>
      </div>
    );
  }

  return (
    <div className="relative h-full overflow-auto px-4 pt-3 pb-10">

      <div className="relative flex flex-col">

        {sortedEventStages.map((stage, index) => {
          const isLastItem = index === sortedEventStages.length - 1;

          return (
            <div
              key={`${stage.eventType}-${index}`}
              className="relative flex gap-[5px]"
            >
              <div className="relative w-5 shrink-0">
                
                {!isLastItem && (
                  <div
                    className="
                      absolute
                      left-[9.5px]
                      top-[14px]
                      bottom-[-14px]
                      w-px
                      bg-[#E5E5E5]
                    "
                  />
                )}

                <span
                  className="
                    absolute
                    top-[6px]
                    left-1/2
                    -translate-x-1/2
                    h-[8px]
                    w-[8px]
                    rounded-full
                    bg-white
                    border-[0.5px]
                    border-[#737373]
                    z-10
                  "
                />
              </div>

              <div className="flex-1">
                <TimelineStage
                  eventType={stage.eventType}
                  events={stage.events}
                  notes={stage.notes}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};